<template>
	<div>
		<div v-if="loggedInEmployee.isAdmin">
			<v-card class="mb-4">
				<v-divider></v-divider>

				<v-card-text>
					<v-subheader class="text-xs-left mb-3"> This section allows you to control the departments within the company. i.e. "HR", "Finance" </v-subheader>

					<departments-list :departments="departments" @onEditDepartment="onEditDepartment" @onDeleteDepartment="onDeleteDepartment"> </departments-list>

					<department-editor :dialog="departmentEditorDialog" :title="departmentEditorTitle" :department="editedDepartment" @save="saveDepartment" @closeEditor="departmentEditorDialog = false"> </department-editor>
				</v-card-text>
			</v-card>

			<v-footer color="" app height="55">
				<v-spacer></v-spacer>
				<footer-add-btn @click="onAddDepartment">Add Department</footer-add-btn>
			</v-footer>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import DepartmentsList from '@/components/DepartmentsList';
	import DepartmentEditor from '@/components/DepartmentEditor';

	export default {
		components: {
			DepartmentsList,
			DepartmentEditor
		},
		data() {
			return {
				departmentEditorDialog: false,
				editedDepartmentIndex: -1,
				editedDepartment: undefined
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Departments');
		},
		computed: {
			...mapGetters({
				departments: 'departments/departments',
				loggedInEmployee: 'loggedInEmployee'
			}),
			departmentEditorTitle() {
				return this.editedDepartmentIndex === -1 ? 'New Department' : 'Edit Department';
			}
		},
		methods: {
			onEditDepartment(department) {
				this.editedDepartmentIndex = this.departments.indexOf(department);
				this.editedDepartment = Object.assign({}, department);
				this.departmentEditorDialog = true;
			},
			onDeleteDepartment(department) {
				const index = this.departments.indexOf(department);
				if (confirm('Are you sure you want to delete this department?')) {
					this.$store.dispatch('departments/delete', department).then(
						(response) => {},
						(error) => {
							console.error('Error deleting department');
						}
					);
				}
			},
			onAddDepartment() {
				this.editedDepartmentIndex = -1;
				this.editedDepartment = undefined;
				this.departmentEditorDialog = true;
			},
			saveDepartment(department) {
				if (this.editedDepartmentIndex > -1) {
					this.$store.dispatch('departments/edit', department).then(
						(response) => {},
						(error) => {
							console.error('Error saving department');
						}
					);
				} else {
					this.$store.dispatch('departments/add', department).then(
						(response) => {},
						(error) => {
							console.error('Error saving department');
						}
					);
				}
			}
		}
	};
</script>

<style></style>
